export const GWPCODES = [
  "WOMJULYGWP",
  "MENJULYGWP",
  "WOM6JULYGWP",
  "MEN6JULYGWP",
]

export const GWPDATAMEN = {
  lineImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/JLCPXuUw2rJ96kVc2tVei/53f3c4996ea28d152ead3b4c092e4d43/dotted-line.png?fl=progressive",
  planeImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/5cJfoq9NzCIWqqJZzsJ5jd/ff7ce663d1f2d51133b0f49651c24d7b/plane-straight-line-men.png?fl=progressive",
  tag: {
    line: "Limited Time Only",
    classes: "bg-men-secondary-alt",
  },
  card: {
    heading: "Up to 2 FREE travel-size samples<sup>‡</sup>",
    copy: "with your hair growth subscription.",
    containerClasses: "justify-center",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4xu3YqT6bCeBOeEiy4guSW/5938ba1185dba131f1ebefc1d01d8f2a/men-active-cleanse-and-serum.png?fl=progressive",
    button: {
      level: "Textlink",
      label: "Learn More",
      icon: "Right",
    },
  },
  atcCard: [
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup> ",
      items: ["Travel 2-in-1 Shampoo and Conditioner"],
      copy: `$13 value. One-time delivery. While supplies last.`,
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
    },
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup> ",
      items: ["Travel 2-in-1 Shampoo and Conditioner"],
      copy: `$13 value. One-time delivery. While supplies last.`,
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
    },
    {
      heading: "FREE with your 6-month subscription:<sup>‡</sup>",
      items: ["Travel 2-in-1 Shampoo and Conditioner", "5 ml Hair Serum"],
      copy: `$28 value. One-time delivery. While supplies last.`,
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/4xu3YqT6bCeBOeEiy4guSW/5938ba1185dba131f1ebefc1d01d8f2a/men-active-cleanse-and-serum.png?fl=progressive",
    },
  ],
  modal: {
    title: "Free travel-size samples / Up to $28 value.<sup>‡</sup>",
    offers: [
      {
        heading: `FREE with your<br class="show-tablet"/> 1- or 3-month subscription:`,
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
        copy: "Support <span class='font-dinamoBold'>visibly thicker, stronger, fuller hair</span> with a one-time delivery of:<sup>1</sup>",
        bullets: ["Travel 2-in-1 Shampoo and Conditioner"],
        value: "$13 value. One-time delivery. While supplies last.",
      },
      {
        heading: `FREE with your<br class="show-tablet"/> 6-month subscription:`,
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/4xu3YqT6bCeBOeEiy4guSW/5938ba1185dba131f1ebefc1d01d8f2a/men-active-cleanse-and-serum.png?fl=progressive",
        copy: "Support <span class='font-dinamoBold'>visibly thicker, stronger, fuller hair</span><sup>1</sup> and <span class='font-dinamoBold'>visibly improved hair density</span><sup>2</sup> with a one-time delivery of:",
        bullets: ["2 oz 2-in-1 Shampoo and Conditioner", "5 mL Hair Serum"],
        value: "$28 value. One-time delivery. While supplies last.",
      },
    ],
    terms:
      "‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires the creation of a new Hair Growth Nutraceutical Subscription on nutrafol.com. Available to new subscribers only. Travel-size samples are a one-time delivery with initial subscription order and are non-refundable or otherwise exchangeable for cash or product. Offer valid only on orders shipped within the United States. Not applicable to international orders. While supplies last.<br/><br/><br/>1. Nutrafol. Data on file. 2024. 2. Nutrafol. Data on file. 2023.",
  },
}

export const GWPDATAMENCOLLAGEN = {
  lineImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/JLCPXuUw2rJ96kVc2tVei/53f3c4996ea28d152ead3b4c092e4d43/dotted-line.png?fl=progressive",
  planeImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/5cJfoq9NzCIWqqJZzsJ5jd/ff7ce663d1f2d51133b0f49651c24d7b/plane-straight-line-men.png?fl=progressive",
  tag: {
    line: "Limited Time Only",
    classes: "bg-men-secondary-alt",
  },
  card: {
    heading: "FREE travel-size sample<sup>‡</sup>",
    copy: "with your hair growth subscription.",
    containerClasses: "justify-center",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
    button: {
      level: "Textlink",
      label: "Learn More",
      icon: "Right",
    },
  },
  atcCard: [
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup> ",
      items: ["Travel 2-in-1 Shampoo and Conditioner"],
      copy: "$13 value. One-time delivery. While supplies last.",
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
    },
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup> ",
      items: ["Travel 2-in-1 Shampoo and Conditioner"],
      copy: "$13 value. One-time delivery. While supplies last.",
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
    },
  ],
  modal: {
    title: "Free travel-size samples / Up to $13 value.<sup>‡</sup>",
    offers: [
      {
        heading: "FREE with your  1- or 3-month subscription:",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/FxWBVxgKO4Li6kLiHGgWY/004f5b1343a24ac30af5ac5ddfd431a4/men-active-cleanse.png?fl=progressive",
        copy: "Support <span class='font-dinamoBold'>visibly thicker, stronger, fuller hair</span> with a one-time delivery of:<sup>1</sup>",
        bullets: ["Travel 2-in-1 Shampoo and Conditioner"],
        value: "$13 value. One-time delivery. While supplies last.",
      },
    ],
    terms:
      "‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires the creation of a new Hair Growth Nutraceutical Subscription on nutrafol.com. Available to new subscribers only. Travel-size samples are a one-time delivery with initial subscription order and are non-refundable or otherwise exchangeable for cash or product. Offer valid only on orders shipped within the United States. Not applicable to international orders. While supplies last.<br/><br/>1. Nutrafol. Data on file. 2024.",
  },
}

export const GWPDATAWOMEN = {
  code: "WOMJULYGWP",
  lineImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/JLCPXuUw2rJ96kVc2tVei/53f3c4996ea28d152ead3b4c092e4d43/dotted-line.png?fl=progressive",
  planeImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/6VjEY9F0VaznMTekFOASon/2ade566625df4b750343252ade22d9df/plane-straight-line-mb.png?fl=progressive",
  tag: {
    line: "Limited Time Only",
    classes: "",
  },
  card: {
    heading: "2 FREE travel-size samples<sup>‡</sup>",
    copy: "with your hair growth subscription.",
    containerClasses: "justify-center",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5unasvDp1Qq9LN6ZmiLFYk/dadb26f535ed52cea3228d2d6b31799d/travel-kit-gwp-july-double.png?fl=progressive&w=250",
    button: {
      level: "Textlink",
      label: "Learn More",
      icon: "Right",
    },
  },
  atcCard: [
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup>",
      bullets: ["2 oz Shampoo", "2 oz Conditioner"],
      value: "$26 value. One-time delivery. While supplies last.",
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/5unasvDp1Qq9LN6ZmiLFYk/dadb26f535ed52cea3228d2d6b31799d/travel-kit-gwp-july-double.png?fl=progressive&w=250",
    },
    {
      heading: "FREE with your 1- or 3-month subscription:<sup>‡</sup>",
      bullets: ["2 oz Shampoo", "2 oz Conditioner"],
      value: "$26 value. One-time delivery. While supplies last.",
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/5unasvDp1Qq9LN6ZmiLFYk/dadb26f535ed52cea3228d2d6b31799d/travel-kit-gwp-july-double.png?fl=progressive&w=250",
    },
    {
      heading: "FREE with your 6-month subscription:<sup>‡</sup>",
      bullets: ["2 oz Shampoo", "2 oz Conditioner", "5 mL Hair Serum"],
      value: "$41 value. One-time delivery. While supplies last.",
      image:
        "https://images.ctfassets.net/0rbfqd9c4jdo/18lJAU8AGEL8t9zogEwMWh/81ff55a5d0fed0b05d58c194ab8db573/travel-kit-gwp-july-triple.png?fl=progressive&w=250",
    },
  ],
  modal: {
    title: "Free travel-size samples / Up to $41 value.<sup>‡</sup>",
    offers: [
      {
        heading:
          "FREE with your<br class='hidden sm:block lg:hidden' /> 1- or 3-month subscription:",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/5unasvDp1Qq9LN6ZmiLFYk/dadb26f535ed52cea3228d2d6b31799d/travel-kit-gwp-july-double.png?fl=progressive",
        copy: "Visibly improve <span class='font-dinamoBold'>hair volume</span> and <span class='font-dinamoBold'>strength</span> with a one-time delivery of:<sup>1</sup>",
        bullets: [
          "2 oz Root Purifier Shampoo",
          "2 oz Strand Defender Conditioner",
        ],
        value: "$26 value. While supplies last.",
      },
    ],
    terms:
      "‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires the creation of a new Hair Growth Nutraceutical Subscription on nutrafol.com. Available to new subscribers only. Travel-size samples are a one-time delivery with initial subscription order and are non-refundable or otherwise exchangeable for cash or product. Offer valid only on orders shipped within the United States. Not applicable to international orders. While supplies last.<br/><br/>1. Nutrafol. Data on file. 2022.",
  },
}

export const GWPTC = `‡Limited time only. One per customer; cannot be combined with other offers or sales. Requires the creation of a new Hair Growth Nutraceutical Subscription on nutrafol.com. Available to new subscribers only. Travel-size samples are a one-time delivery with initial subscription order and are non-refundable or otherwise exchangeable for cash or product. Offer valid only on orders shipped within the United States. Not applicable to international orders. While supplies last.`
